module.exports = __webpack_public_path__ + "static/media/calling.d6c5c06d.gif";